import { Box } from "@mui/material"
import ZeldaLullabySong from "../inventory/songs/ZeldaLullabySong"
import EponaSong from "../inventory/songs/EponaSong"
import SariaSong from "../inventory/songs/SariaSong"
import SunSong from "../inventory/songs/SunSong"
import TimeSong from "../inventory/songs/TimeSong"
import StormSong from "../inventory/songs/StormSong"
import { isNil } from "lodash"

interface ReworkChildSongTrackerProps{
    top?: number,
    left?: number,
    display: "horizontal" | "vertical"
    cleft?: boolean,
    cright?: boolean,
    cup?: boolean,
    cdown?: boolean,
    a?: boolean
}


const ReworkChildSongTracker = (props: ReworkChildSongTrackerProps) => {

    let {cleft, cright, cup, cdown, a} = props;

    if(props.display === "horizontal")
        return <Box display={"flex"} flexDirection={"row"} position={isNil(props.top) || isNil(props.left) ? undefined : "absolute"}  top={props.top} left={props.left}>
            <Box display={"flex"}>
                <ZeldaLullabySong cleft={cleft ?? true} cright={cright ?? true} cup={cup ?? true} display="horizontal" />
            </Box>
            <Box display={"flex"}>
                <EponaSong cleft={cleft ?? true} cright={cright ?? true} cup={cup ?? true} display="horizontal" />
            </Box>
            <Box display={"flex"}>
                <SariaSong cleft={cleft ?? true} cright={cright ?? true} cdown={cdown ?? true} display="horizontal" />
            </Box>
            <Box display={"flex"}>
                <SunSong cdown={cdown ?? true} cright={cright ?? true} cup={cup ?? true} display="horizontal" />
            </Box>
            <Box >
                <TimeSong a={a ?? true} cdown={cdown ?? true} cright={cright ?? true} display="horizontal" />
            </Box>
            <Box >
                <StormSong a={a ?? true} cdown={cdown ?? true} cup={cup ?? true} display="horizontal" />
            </Box>
        </Box>

return <Box position={isNil(props.top) || isNil(props.left) ? undefined : "absolute"} display={"flex"}  flexDirection={"column"} justifyContent={"flex-start"}>
    <Box display={"flex"}>
        <ZeldaLullabySong cleft={cleft ?? true} cright={cright ?? true} cup={cup ?? true} display="vertical" />
    </Box>
    <Box display={"flex"}>
        <EponaSong cleft={cleft ?? true} cright={cright ?? true} cup={cup ?? true} display="vertical" />
    </Box>
    <Box display={"flex"}>
        <SariaSong cleft={cleft ?? true} cright={cright ?? true} cdown={cdown ?? true} display="vertical" />
    </Box>
    <Box display={"flex"}>
        <SunSong cdown={cdown ?? true} cright={cright ?? true} cup={cup ?? true} display="vertical" />
    </Box>
    <Box display={"flex"}>
        <TimeSong a={a ?? true} cdown={cdown ?? true} cright={cright ?? true} display="vertical" />
    </Box>
    <Box display={"flex"}>
        <StormSong a={a ?? true} cdown={cdown ?? true} cup={cup ?? true} display="vertical" />
    </Box>
</Box>
}

export default ReworkChildSongTracker